import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import { BadgeComponent } from '../../badge/badge.component';
import type { BadgeColor } from '../../badge/badge.types';
import { DotComponent } from '../../dot/dot.component';

@Component({
  selector: 'rt-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.disabled]': 'disabled()',
  },
  imports: [DotComponent, BadgeComponent],
})
export class TabComponent {
  public readonly isUnread = input<boolean>(false);
  public readonly countColor = input<BadgeColor>('counter-default');
  public readonly disabled = input<boolean>(false);
  public readonly noRightPadding = input<boolean>(false);
  @Input() public count: number | string = 0;
  @Input() public href: string;
  @Input() public hrefTarget: string;
}
